import { defineStore } from 'pinia';
import { ref } from 'vue';

/// 进入到应用的首次页面路径信息
export const useEntryURLStore = defineStore(
  'entryURL',
  () => {
    const entryURL = ref<string | null>(null);
    const setEntryURL = (url: string) => {
      entryURL.value = url;
    };

    return {
      setEntryURL,
      entryURL,
    };
  },
  {
    persist: true,
  },
);
